import { render, staticRenderFns } from "./special_message_banner.vue?vue&type=template&id=d5127976&"
import script from "./special_message_banner.vue?vue&type=script&lang=js&"
export * from "./special_message_banner.vue?vue&type=script&lang=js&"
import style0 from "./special_message_banner.vue?vue&type=style&index=0&id=d5127976&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports